import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-12 text-center" }
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = {
  key: 0,
  class: "col-12"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = {
  key: 1,
  class: "col-12 col-md-7"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Entra con SPID", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Entra con il Sistema Pubblico per la gestione dell'Identità Digitale "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" SPID è il sistema di accesso che consente di utilizzare, con un'identità digitale unica, i servizi online della Pubblica Amministrazione e dei privati accreditati. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Se sei già in possesso di un'identità digitale, accedi con le credenziali del tuo gestore. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Se non hai ancora un'identità digitale, richiedila ad uno dei gestori. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", {
  href: "http://www.spid.gov.it",
  target: "_blank"
}, "Maggiori informazioni su SPID", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("a", {
  href: "http://www.spid.gov.it/#spid-idp",
  target: "_blank"
}, "Non hai SPID?", -1)
const _hoisted_13 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9,
  _hoisted_10,
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = {
  class: "row d-flex justify-content-center",
  style: {"text-align":"center"}
}
const _hoisted_15 = { class: "italia-it-button-icon" }
const _hoisted_16 = ["src"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "italia-it-button-text" }, "Entra con SPID", -1)
const _hoisted_18 = {
  id: "spid-idp-button-large-get",
  class: "spid-idp-button spid-idp-button-tip spid-idp-button-relative"
}
const _hoisted_19 = {
  id: "spid-idp-list-large-root-get",
  class: "spid-idp-button-menu",
  "aria-labelledby": "spid-idp"
}
const _hoisted_20 = {
  class: "spid-idp-button-link",
  "data-idp": "arubaid"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "spid-sr-only" }, "Aruba ID", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", {
  src: "/img/spid-idp-arubaid.svg",
  onerror: "this.src='/img/spid-idp-arubaid.png'; this.onerror=null;",
  alt: "Aruba ID"
}, null, -1)
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = {
  class: "spid-idp-button-link",
  "data-idp": "infocertid"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "spid-sr-only" }, "Infocert ID", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("img", {
  src: "/img/spid-idp-infocertid.svg",
  onerror: "this.src='/img/spid-idp-infocertid.png'; this.onerror=null;",
  alt: "Infocert ID"
}, null, -1)
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = {
  class: "spid-idp-button-link",
  "data-idp": "intesaid"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "spid-sr-only" }, "Intesa ID", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("img", {
  src: "/img/spid-idp-intesaid.svg",
  onerror: "this.src='/img/spid-idp-intesaid.png'; this.onerror=null;",
  alt: "Intesa ID"
}, null, -1)
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = {
  class: "spid-idp-button-link",
  "data-idp": "lepidaid"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "spid-sr-only" }, "Lepida ID", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("img", {
  src: "/img/spid-idp-lepidaid.svg",
  onerror: "this.src='/img/spid-idp-lepidaid.png'; this.onerror=null;",
  alt: "Lepida ID"
}, null, -1)
const _hoisted_35 = [
  _hoisted_33,
  _hoisted_34
]
const _hoisted_36 = {
  class: "spid-idp-button-link",
  "data-idp": "namirialid"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "spid-sr-only" }, "Namirial ID", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("img", {
  src: "/img/spid-idp-namirialid.svg",
  onerror: "this.src='/img/spid-idp-namirialid.png'; this.onerror=null;",
  alt: "Namirial ID"
}, null, -1)
const _hoisted_39 = [
  _hoisted_37,
  _hoisted_38
]
const _hoisted_40 = {
  class: "spid-idp-button-link",
  "data-idp": "posteid"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", { class: "spid-sr-only" }, "Poste ID", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("img", {
  src: "/img/spid-idp-posteid.svg",
  onerror: "this.src='/img/spid-idp-posteid.png'; this.onerror=null;",
  alt: "Poste ID"
}, null, -1)
const _hoisted_43 = [
  _hoisted_41,
  _hoisted_42
]
const _hoisted_44 = {
  class: "spid-idp-button-link",
  "data-idp": "sielteid"
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "spid-sr-only" }, "Sielte ID", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("img", {
  src: "/img/spid-idp-sielteid.svg",
  onerror: "this.src='/img/spid-idp-sielteid.png'; this.onerror=null;",
  alt: "Sielte ID"
}, null, -1)
const _hoisted_47 = [
  _hoisted_45,
  _hoisted_46
]
const _hoisted_48 = {
  class: "spid-idp-button-link",
  "data-idp": "spiditalia"
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", { class: "spid-sr-only" }, "SPIDItalia Register.it", -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("img", {
  src: "/img/spid-idp-spiditalia.svg",
  onerror: "this.src='/img/spid-idp-spiditalia.png'; this.onerror=null;",
  alt: "SpidItalia"
}, null, -1)
const _hoisted_51 = [
  _hoisted_49,
  _hoisted_50
]
const _hoisted_52 = {
  class: "spid-idp-button-link",
  "data-idp": "timid"
}
const _hoisted_53 = /*#__PURE__*/_createElementVNode("span", { class: "spid-sr-only" }, "Tim ID", -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("img", {
  src: "/img/spid-idp-timid.svg",
  onerror: "this.src='/img/spid-idp-timid.png'; this.onerror=null;",
  alt: "Tim ID"
}, null, -1)
const _hoisted_55 = [
  _hoisted_53,
  _hoisted_54
]
const _hoisted_56 = /*#__PURE__*/_createStaticVNode("<li class=\"spid-idp-support-link\" data-spidlink=\"info\"><a href=\"https://www.spid.gov.it\">Maggiori informazioni</a></li><li class=\"spid-idp-support-link\" data-spidlink=\"rich\"><a href=\"https://www.spid.gov.it/richiedi-spid\">Non hai SPID?</a></li><li class=\"spid-idp-support-link\" data-spidlink=\"help\"><a href=\"https://www.spid.gov.it/serve-aiuto\">Serve aiuto?</a></li>", 3)
const _hoisted_59 = { key: 0 }
const _hoisted_60 = ["href"]

import { computed, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "../../models/Store/store";
import { useTenantConfig } from "../../composables/useTenantConfig";
import { useWidget } from "@/composables/useWidget";
import { useI18n } from "vue-i18n";
import { ExternalLoginBackUrlData } from "@/models/ExternalLogin/ExternalLoginBackUrlData";


export default /*#__PURE__*/_defineComponent({
  __name: 'BookFormChoice',
  setup(__props) {

const { baseUrl } = useWidget();
const router = useRouter();
const store = useStore();
const tenantConfigs = useTenantConfig();
const { t } = useI18n();
const { hasConfiguration, hasUserDataAsForm, hasUserDataAsSpid, hasUserDataAsExternalLogin, getUserDataExternalLoginLink } = useTenantConfig();

const colMdValue = ref(6);

const spidErrorMessage = ref("");

onMounted(() => {
    router.replace({ name: "bookuserdata" });
    return;

    let spidscript = document.getElementById("__spidScript");
    if (!spidscript) {
        spidscript = document.createElement("script");
        spidscript.setAttribute("id", "__spidScript");
        spidscript.setAttribute("src", "../js/spid-sp-access-button.min.js");
        document.head.appendChild(spidscript);
    }

    let spidrandscript = document.getElementById("__spidRandScript");
    if (!spidrandscript) {
        spidrandscript = document.createElement("script");
        spidrandscript.setAttribute("id", "__spidRandScript");
        spidrandscript.setAttribute("src", "../js/spid-sp-random.js");
        document.head.appendChild(spidrandscript);
    }

    store.stepsMade.spid = null;
    if (store.spidResponse) {
        const spidResponse = store.spidResponse;
        if (spidResponse.Error) {
            spidErrorMessage.value = spidResponse.Error;
        }
        if (spidResponse.Response_StatusMessage) {
            spidErrorMessage.value = spidErrorMessage.value + " " + spidResponse.Response_StatusMessage;
        }
        if (spidResponse.Response_StatusDetail) {
            spidErrorMessage.value = spidErrorMessage.value + " " + spidResponse.Response_StatusDetail;
        }
        if (spidResponse.Response_StatusCodeInnervalue && spidResponse.Response_StatusCodeInnervalue === "AuthnFailed") {
            spidErrorMessage.value = spidErrorMessage.value + " " + "Autenticazione fallita";
        }
    } else if (store.bookedit) {
        router.replace({ name: "bookuserdata" });
    } else if (store.userLoggedData) {
        router.replace({ name: "bookuserdata" });
    } else if (hasConfiguration.value) {
        if (hasUserDataAsForm.value && !hasUserDataAsSpid.value && !hasUserDataAsExternalLogin.value) {
            router.replace({ name: "bookuserdata" });
        }
    }

    var loginActive = 0;
    if (hasUserDataAsForm.value) loginActive++;
    if (hasUserDataAsSpid.value) loginActive++;
    if (hasUserDataAsExternalLogin.value) loginActive++;

    colMdValue.value = 12 / loginActive;
});

const openSpidLogin = (entityId: string) => {
    store.spidResponse = null;
    store.stepsMade.spid = true;
    window.location.href = baseUrl.value + "/v1/spid/login?idpname=" + entityId;
};

const goToFormData = () => {
    store.spidResponse = null;
    store.stepsMade.spid = null;
    router.push({ name: "bookuserdata" });
};

const onExternalLoginClick = () => {
    let backUrlData: ExternalLoginBackUrlData = {
        tenantId: store.tenantSelected.id,
        stepsMade: store.stepsMade
    };

    let backUrlDataJson = JSON.stringify(backUrlData);
    let backUrlDataEnc64 = btoa(backUrlDataJson);
    let backUrlDataEncoded = encodeURIComponent(backUrlDataEnc64);

    console.log(backUrlDataEncoded);
};

const getExternalLoginUrl = computed(() => {
    let link = tenantConfigs.getUserDataExternalLoginLink.value;
    if (link) {
        let backUrlData: ExternalLoginBackUrlData = {
            tenantId: store.tenantSelected.id,
            stepsMade: store.stepsMade
        };

        let backUrlDataJson = JSON.stringify(backUrlData);
        let backUrlDataEnc64 = btoa(backUrlDataJson);
        let backUrlDataEncoded = encodeURIComponent(backUrlDataEnc64);

        link = link.replace("{returnUrl}", `data=${backUrlDataEncoded}`);
    }

    return link;
});

const userDataOnlySpid = computed(() => {
    return hasUserDataAsSpid.value && !hasUserDataAsForm.value && !hasUserDataAsExternalLogin;
});

const spidHasErrors = computed(() => {
    return store.spidResponse != null;
});

const icoSpid = computed(() => {
    return __webpack_public_path__ + "img/spid-ico-circle-bb.svg";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", null, _toDisplayString(_unref(t)("titles.choiceInputDataMethod")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (spidHasErrors.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("label", null, [
              _createTextVNode(" Sì è verificato un errore in fase di autenticazione con SPID:"),
              _hoisted_5,
              _createTextVNode(" " + _toDisplayString(spidErrorMessage.value), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (userDataOnlySpid.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_13))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_14, [
      (_unref(hasUserDataAsSpid))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["col-12 align-self-center", ` col-md-${colMdValue.value} `])
          }, [
            _createElementVNode("span", null, [
              _createElementVNode("a", {
                href: "#",
                class: "italia-it-button italia-it-button-size-l button-spid",
                "spid-idp-button": "#spid-idp-button-xlarge-get",
                "aria-haspopup": "true",
                "aria-expanded": "false",
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
              }, [
                _createElementVNode("span", _hoisted_15, [
                  _createElementVNode("img", {
                    src: icoSpid.value,
                    alt: ""
                  }, null, 8, _hoisted_16)
                ]),
                _hoisted_17
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("ul", _hoisted_19, [
                  _createElementVNode("li", _hoisted_20, [
                    _createElementVNode("a", {
                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (openSpidLogin('https://loginspid.aruba.it')), ["prevent"]))
                    }, _hoisted_23)
                  ]),
                  _createElementVNode("li", _hoisted_24, [
                    _createElementVNode("a", {
                      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (openSpidLogin('https://identity.infocert.it')), ["prevent"]))
                    }, _hoisted_27)
                  ]),
                  _createElementVNode("li", _hoisted_28, [
                    _createElementVNode("a", {
                      onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (openSpidLogin('https://spid.intesa.it')), ["prevent"]))
                    }, _hoisted_31)
                  ]),
                  _createElementVNode("li", _hoisted_32, [
                    _createElementVNode("a", {
                      onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (openSpidLogin('https://id.lepida.it/idp/shibboleth')), ["prevent"]))
                    }, _hoisted_35)
                  ]),
                  _createElementVNode("li", _hoisted_36, [
                    _createElementVNode("a", {
                      onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (openSpidLogin('https://idp.namirialtsp.com/idp')), ["prevent"]))
                    }, _hoisted_39)
                  ]),
                  _createElementVNode("li", _hoisted_40, [
                    _createElementVNode("a", {
                      onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (openSpidLogin('https://posteid.poste.it')), ["prevent"]))
                    }, _hoisted_43)
                  ]),
                  _createElementVNode("li", _hoisted_44, [
                    _createElementVNode("a", {
                      onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (openSpidLogin('https://identity.sieltecloud.it')), ["prevent"]))
                    }, _hoisted_47)
                  ]),
                  _createElementVNode("li", _hoisted_48, [
                    _createElementVNode("a", {
                      onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (openSpidLogin('https://spid.register.it')), ["prevent"]))
                    }, _hoisted_51)
                  ]),
                  _createElementVNode("li", _hoisted_52, [
                    _createElementVNode("a", {
                      onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (openSpidLogin('https://login.id.tim.it/affwebservices/public/saml2sso')), ["prevent"]))
                    }, _hoisted_55)
                  ]),
                  _hoisted_56
                ])
              ])
            ]),
            (!userDataOnlySpid.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_59))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true),
      (_unref(hasUserDataAsExternalLogin))
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["col-12", ` col-md-${colMdValue.value} `])
          }, [
            _createElementVNode("a", {
              href: getExternalLoginUrl.value,
              type: "button",
              class: "btn btn-primary btn-lg my-3",
              target: "_self"
            }, _toDisplayString(_unref(t)("common.externalLogin")), 9, _hoisted_60)
          ], 2))
        : _createCommentVNode("", true),
      (_unref(hasUserDataAsForm))
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass(["col-12", ` col-md-${colMdValue.value} `])
          }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary btn-lg my-3",
              onClick: _withModifiers(goToFormData, ["prevent"])
            }, _toDisplayString(_unref(t)("common.manualInput")), 1)
          ], 2))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})